export default __webpack_public_path__ + "19d79761453c999e1f4e7fae6b80c23d.webp";